import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { EXCHANGE_RATE_PATH } from '../../../../config/paths';
import {
  clearExchangeRate,
  getExchangeRate,
  putExchangeRate,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import ExchangeRateForm from './ExchangeRateForm';
import { CURRENCY_CODE } from '../../../../config/constants';

const EditExchangeRate = ({
  breadcrumbs,
  dispatchGetExchangeRate,
  dispatchClearExchangeRate,
  dispatchPutExchangeRate,
  match: {
    params: { id: exchangeRateId },
  },
  loading,
  exchangeRate,
}) => {
  useLayoutEffect(() => {
    dispatchGetExchangeRate({ exchangeRateId });

    return () => dispatchClearExchangeRate();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutExchangeRate(exchangeRateId, {
      ...formValues,
      currency: formValues.currencyId.value,
    });

  const generateInitialValues = ({
    rate,
    currency
  }) => ({
    rate,
    currencyId: CURRENCY_CODE[currency]
  });

  let content;

  if (loading) content = <Loader />;
  else if (exchangeRate.isEmpty())
    content = <NoDataResource returnPage={EXCHANGE_RATE_PATH} />;
  else
    content = (
      <ExchangeRateForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(exchangeRate.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Tasa de Cambio"
      subtitle="Editar tasa de cambio"
      content={content}
    />
  );
};

EditExchangeRate.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearExchangeRate: PropTypes.func.isRequired,
  dispatchGetExchangeRate: PropTypes.func.isRequired,
  dispatchPutExchangeRate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  exchangeRate: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditExchangeRate.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearExchangeRate: clearExchangeRate,
  dispatchGetExchangeRate: getExchangeRate,
  dispatchPutExchangeRate: putExchangeRate,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tasas de Cambio',
      href: EXCHANGE_RATE_PATH,
    },
    {
      text: 'Ver',
      href: `${EXCHANGE_RATE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  exchangeRate: AccountingUnit.ExchangeRate.getIn(['current', 'content']),
  loading: !AccountingUnit.ExchangeRate.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditExchangeRate);
